// Дзеркало Prisma enum ScheduleObjectKind. Об'єкт розкладу (публічні посилання, iCal, пошук).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const ScheduleObjectKind = {
    UNIVERSITY: 'UNIVERSITY',
    FACULTY: 'FACULTY',
    DEPARTMENT: 'DEPARTMENT',
    GROUP: 'GROUP',
    SUBGROUP: 'SUBGROUP',
    STREAM: 'STREAM',
    TEACHER: 'TEACHER',
    ROOM: 'ROOM',
    LOCATION: 'LOCATION',
};
/** Значення в порядку оголошення в схемі. */
export const SCHEDULE_OBJECT_KIND_VALUES = ['UNIVERSITY', 'FACULTY', 'DEPARTMENT', 'GROUP', 'SUBGROUP', 'STREAM', 'TEACHER', 'ROOM', 'LOCATION'];
export const SCHEDULE_OBJECT_KIND_LABELS = {
    UNIVERSITY: 'Університет',
    FACULTY: 'Факультет',
    DEPARTMENT: 'Кафедра',
    GROUP: 'Група',
    SUBGROUP: 'Підгрупа',
    STREAM: 'Потік',
    TEACHER: 'Викладач',
    ROOM: 'Аудиторія',
    LOCATION: 'Локація',
};
//# sourceMappingURL=schedule-object-kind.js.map